import { all } from '@wrisk/styled-system'

const forwardedProps = ['data-testid', 'variant']

const disallowedProps = [
  'displayOn',
  'typoSize',
  'whiteSpace',
  'textTransform',
  'gap',
  'columnGap',
  'rowGap',
  'collapseWhenEmpty',
  'wordWrap',
  'wordBreak',
  'isActive',
  'backgroundUrl',
].concat(all.propNames ?? [])

export const shouldForwardProp = (prop: string): boolean =>
  forwardedProps.includes(prop) || !disallowedProps.includes(prop)
